import { Button, Table, Modal } from "antd";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const CheckPointTable = ({ checkPoint = [] }) => {
  const [data, setData] = useState([]);
  const [showAll, setShowAll] = useState(false); // State to manage view mode
  const [isModalVisible, setIsModalVisible] = useState(false); // State to manage modal visibility
  const [selectedImage, setSelectedImage] = useState(null); // State to store selected image URL

  useEffect(() => {
    setData(checkPoint);
  }, [checkPoint]);

  // Handle image click to show modal with the large image
  const handleImageClick = (imageUrl) => {
    setSelectedImage(imageUrl); // Set the selected image URL
    setIsModalVisible(true); // Show the modal
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <h2 className="table-avatar">
          <Link to="#" className="avatar">
            {/* Add onClick handler to show large image in modal */}
            <img
              alt=""
              src={record.imageUrl}
              onClick={() => handleImageClick(record.imageUrl)}
              style={{ cursor: "pointer" }} // Change cursor to pointer to indicate it's clickable
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            />
          </Link>
          <Link to="#" className="ant-table-cell">
            {text} <span>{record.role}</span>
          </Link>
        </h2>
      ),
    },
  ];

  return (
    <div className="col-md-12 d-flex">
      <div className="card card-table flex-fill">
        <div className="card-header">
          <h3 className="card-title mb-0">CheckPoint</h3>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <Table
              dataSource={data}
              columns={columns}
              pagination={false}
              rowKey={(record) => record.id}
            />
          </div>
        </div>
        <div className="card-footer">
          {/* <Button
            onClick={() => setShowAll(!showAll)}
            block // This makes the button full-width
          >
            {showAll ? "Show Less" : "View All"}
          </Button> */}
        </div>
      </div>

      {/* Modal to display large image */}
      <div
        class="modal fade"
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          {/* <div class="modal-content"> */}
          <div class="card">
            <img
              src={selectedImage}
              className="rounded"
              alt="..."
              style={{ height: "100%" }}
            />
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default CheckPointTable;
